module.exports = {
      id: "search-usage",
      viewBox: "0 0 20 20.051",
      url: "/" + "sprite-bc5ff1507898764e0c54e53c34039c01.svg#search",
      toString: function () {
        return this.url;
      }
    }